import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { QSAReport } from 'src/modules/motor-credito/serasa/serasa.experian.business.types'
import { formatDate } from 'date-fns'

export type ControleAdministracaoProps = {
    controleAdministracao?: QSAReport
}

export default function ControleAdministracao({ controleAdministracao }: ControleAdministracaoProps) {
    return (
        <>
            <Divider textAlign="center">Controle de Administração</Divider>
            {controleAdministracao &&
                controleAdministracao.directorCompleteReport &&
                controleAdministracao.directorCompleteReport.directorsList &&
                controleAdministracao.directorCompleteReport.directorsList.length > 0 && (
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            paddingTop: 2,
                            paddingBottom: 2,
                            paddingLeft: 5,
                            paddingRight: 5
                        }}
                    >
                        {controleAdministracao.directorCompleteReport.directorsList.map((admin, index) => (
                            <Grid key={index} container spacing={1}>
                                <GridItem label="Administrador" value={admin.name || '-'} xs={6} />
                                <GridItem label="Cargo" value={admin.role || '-'} xs={6} />
                                <GridItem label="Nacionalidade" value={admin.nationality || '-'} xs={6} />
                                <GridItem
                                    label="Data de Entrada"
                                    value={admin.sinceDate ? formatDate(admin.sinceDate, 'dd/MM/yyyy') : '-'}
                                    xs={6}
                                />
                                <GridItem
                                    label="Mandato"
                                    value={admin.mandateEnd ? formatDate(admin.mandateEnd, 'dd/MM/yyyy') : 'INDET.'}
                                    xs={6}
                                />
                            </Grid>
                        ))}
                    </Grid>
                )}
        </>
    )
}
